import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import { RoleName, RoleNameValue } from '@m/types/api/iam/Iam';

import { getKeycloakServerClientResourceId } from './serverResource';

const INHERITED_ROLES: Partial<Record<string, RoleNameValue[]>> = {
  [RoleName.SYSTEM_ADMIN]: [
    RoleName.SYSTEM_ADMIN,
    RoleName.SUPER_ADMIN,
    RoleName.OPERATIONAL_ADMIN,
  ],
  [RoleName.SUPER_ADMIN]: [RoleName.SUPER_ADMIN, RoleName.OPERATIONAL_ADMIN],
  [RoleName.OPERATIONAL_ADMIN]: [RoleName.OPERATIONAL_ADMIN, RoleName.LEADER, RoleName.MANAGER],
  [RoleName.LEADER]: [RoleName.LEADER],
  [RoleName.MANAGER]: [RoleName.MANAGER],
  [RoleName.ENFORCEMENT]: [RoleName.ENFORCEMENT],
  [RoleName.VALET]: [RoleName.VALET],
  [RoleName.OPERATOR]: [RoleName.OPERATOR],
  [RoleName.PORTAL_ASSOCIATE]: [RoleName.PORTAL_ASSOCIATE],
  [RoleName.CUSTOMER_SUPPORT]: [RoleName.CUSTOMER_SUPPORT],

  // todo: ask BE to return inherited roles
};

export function hasRoles(allowedRoles: RoleNameValue[]) {
  const parsedToken = KeycloakService.getTokenParsed();
  const resourceAccess = parsedToken?.resource_access || {};
  const clientId = getKeycloakServerClientResourceId();
  if (clientId in resourceAccess) {
    const { roles } = resourceAccess[clientId];
    const inheritedRoles = roles.flatMap((role) => INHERITED_ROLES[role] ?? []);
    return inheritedRoles.filter((r) => allowedRoles.indexOf(r) > -1).length > 0;
  }

  return false;
}
